'use strict';

goog.provide("Ntry.Ebs2015Hint");

Ntry.Ebs2015Hint = function() {
    this._view = Ntry.interfaceManager.getDom('ntryHintArea');
    this.createDom();
};

(function(p){

    p.createDom = function () {
        var that = this;
        var parent = this._view;

        var header = Ntry.createElement('div', parent, null, 'ntryHintHeader');

        Ntry.createElement('span', header, null, 'ntryHintQuestionNumber').
            innerHTML = '도움말';

        var hintContainer = Ntry.createElement('span', header, null, 'ntryHintContainer');
        this._hintTitle = Ntry.createElement('div', hintContainer, null, 'ntryHintTitle');
        this._hintContent = Ntry.createElement('div', parent, null, 'ntryHintContent');

    };

    p.update = function() {
    };

    p.loadConfig = function () {
        this.position();
        this._hint = Ntry.configManager.getConfig('hint');
        this.fillHintContent();
    };

    p.fillHintContent = function () {
        var hint = this._hint,
            title = this._hintTitle,
            content = this._hintContent,
            detail = this._hintDetail;

        title.innerHTML = hint.title;
        content.innerHTML = hint.content;
    };

    p.position = function() {
        var gridSize = Ntry.configManager.getConfig("gridSize");
        var tileSize = Ntry.configManager.getConfig("tileSize");
        var engineHeight = $(Ntry.interfaceManager.getDom('ntryEngine')).height();
        var adjust = gridSize.height > 3 ? 1/gridSize.width*7 : 1;
        var top = gridSize.height*tileSize*adjust + engineHeight + 13;
        $(this._view).css('top', top+'px');
    };

})(Ntry.Ebs2015Hint.prototype);


